"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeepLinkPromo = void 0;

var _context = require("../context");

var _settings = require("../../settings");

var useDeepLinkPromo = function useDeepLinkPromo(_a) {
  var _b = _a.promo,
      promoState = _b === void 0 ? '' : _b,
      setPromo = _a.setPromo;

  var _c;

  var dispatch = (0, _context.useDeepLinkDispatch)();
  var promo = (0, _context.useDeepLinkState)().promo;
  var settings = (0, _settings.useSettings)().data;

  if (((_c = settings === null || settings === void 0 ? void 0 : settings.FEATURE) === null || _c === void 0 ? void 0 : _c.DEEP_LINK) && !promoState && promo && setPromo) {
    setPromo(promo);
    dispatch({
      type: _context.Actions.UNSET,
      payload: _context.StateKeys.Promo
    });
  }
};

exports.useDeepLinkPromo = useDeepLinkPromo;